module.exports = __webpack_public_path__ + "media/images/varta/VARTA_Promotive_Black_470x520-b7d749a9483cac5d4aaa99d7a1e346e7.png";